import { getReq } from '../../utils/request'
import { IDashboard } from '../../reducers/dashboard/actions'

const fetchDashboardWeek = async ({
	filterOutFrequencies = [],
	weeksBack = 0
}: {
	filterOutFrequencies?: string[];
	weeksBack?: number;
} = {}) => {
	const { data } = await getReq('/api/admin/dashboard/week', {
		filterOutFrequencies: filterOutFrequencies.map((frequency) => frequency.toUpperCase()),
		weeksBack
	})

	return data as IDashboard
}

export default fetchDashboardWeek
